import { deleteObject } from 'firebase/storage';
import { logEvent } from 'src/utils/LogEvent';

export async function safeDeleteObject(ref) {
  try {
    await deleteObject(ref);
  } catch (err) {
    console.error(`Delete storage object error: ${err}`);
    logEvent(err);
  }
}

/**
 * The name has to be percent-encoded, as `filename*=` requires (RFC 5987): Chrome splits a raw comma into
 * several Content-Disposition values and then refuses the response with
 * ERR_RESPONSE_HEADERS_MULTIPLE_CONTENT_DISPOSITION, so neither preview nor download works (HR-5000).
 *
 * @param {string} fileName
 * @return {string}
 */
export function getAttachmentContentDisposition(fileName) {
  // encodeURIComponent throws on a lone UTF-16 surrogate, which a Windows file name can contain; the `u` flag
  // leaves valid surrogate pairs alone
  const wellFormedName = fileName.replace(/[\uD800-\uDFFF]/gu, '\uFFFD');
  const encodedName = encodeURIComponent(wellFormedName)
    .replace(/['()*]/g, (char) => `%${char.charCodeAt(0).toString(16).toUpperCase()}`);
  return `attachment; filename*=utf-8''${encodedName}`;
}
